export const SEQUENTIAL_BASE = "#2a78d6";
export const SEQUENTIAL_ACCENT = "#184f95";
export const DEEMPHASIS_GRAY = "#c3c2b7";
export const GRID_COLOR = "#e1e0d9";
export const MUTED_TEXT = "#898781";

export const CATEGORICAL_PALETTE = [
  "#2a78d6",
  "#eb6834",
  "#1baf7a",
  "#eda100",
  "#e87ba4",
  "#008300",
  "#4a3aa7",
  "#e34948",
];

export { resolveActivityIcon, getFallbackActivityIcon } from "../../../../components/IconPicker/activityIcons";

export interface AccentGradient {
  base: string;
  dark: string;
}

export const CATEGORICAL_GRADIENTS: AccentGradient[] = [
  { base: "#2a78d6", dark: "#184f95" },
  { base: "#eb6834", dark: "#a8431a" },
  { base: "#1baf7a", dark: "#0f7a54" },
  { base: "#eda100", dark: "#a86e00" },
  { base: "#e87ba4", dark: "#b84c76" },
  { base: "#4a3aa7", dark: "#332674" },
  { base: "#008300", dark: "#005900" },
  { base: "#e34948", dark: "#a82b2a" },
];

export const getCardAccent = (index: number): AccentGradient =>
  CATEGORICAL_GRADIENTS[index % CATEGORICAL_GRADIENTS.length];

// Shared white "card" shell for every custom ApexCharts tooltip in this
// feature, so hover tooltips look consistent across charts regardless of
// whatever theme classes ApexCharts' own tooltip container happens to pick.
export const renderTooltipCard = (innerHtml: string): string => `
  <div style="background:#ffffff;color:#0b0b0b;border:1px solid rgba(11,11,11,0.08);box-shadow:0 10px 28px -8px rgba(16,24,40,0.28);border-radius:10px;padding:10px 14px;min-width:170px;">
    ${innerHtml}
  </div>
`;

export const renderTooltipStatusRow = (label: string, count: number): string => `
  <div style="display:flex;align-items:center;justify-content:space-between;gap:16px;font-size:12px;color:#52514e;margin-top:4px;">
    <span>${label}</span>
    <strong style="color:#0b0b0b;">${count}</strong>
  </div>
`;

export const renderTooltipHeader = (
  label: string,
  count: number,
  swatch?: string
): string => `
  <div style="display:flex;align-items:center;gap:8px;font-weight:700;font-size:13px;color:#0b0b0b;">
    ${
      swatch
        ? `<span style="width:10px;height:10px;border-radius:50%;background:${swatch};display:inline-block;"></span>`
        : ""
    }
    ${label} · ${count}
  </div>
`;

// Header for tooltips that cross a series label (a type or status) with a
// CRM entity — reads as "{count} · {label} · [entity]", the entity set off
// as its own pill so it doesn't blur into the label it's qualifying.
export const renderTooltipEntityHeader = (
  count: number,
  label: string,
  entityLabel: string,
  swatch?: string
): string => `
  <div style="display:flex;align-items:center;gap:8px;font-weight:700;font-size:13px;color:#0b0b0b;">
    ${
      swatch
        ? `<span style="width:10px;height:10px;border-radius:50%;background:${swatch};display:inline-block;flex-shrink:0;"></span>`
        : ""
    }
    <span style="white-space:nowrap;">${count} · ${label}</span>
    <span style="background:#f1f0ee;color:#52514e;border-radius:999px;padding:2px 9px;font-size:11px;font-weight:700;letter-spacing:0.02em;white-space:nowrap;">${entityLabel}</span>
  </div>
`;
